import moment from "moment";
import React from "react";
import modalStyles from "./styles.module.css";

const DeleteSlot = ({ slot }) => {
  const date = moment(slot.from).format("dddd, MMMM DD, YYYY");
  const startTime = moment(slot.from).format("hh:mm A");
  const endTime = moment(slot.to).add(1, "seconds").startOf("minute").format("hh:mm A");

  return (
    <div className={modalStyles.summaryContent} style={{ color: '#c53030' }}>
      <div className={modalStyles.summaryRow}>
        <span>Date</span>
        <span>{date}</span>
      </div>
      <div className={modalStyles.summaryRow}>
        <span>From</span>
        <span>{startTime}</span>
      </div>
      <div className={modalStyles.summaryRow}>
        <span>To</span>
        <span>{endTime}</span>
      </div>
      <div className={modalStyles.summaryRow}>
        <span>Status</span>
        <span>Available</span>
      </div>
    </div>
  );
};

export default DeleteSlot;
